import { useEffect, useState } from "react";
import AdminCrudPage from "../Commaon/AdminCrudPage";
import { AuthInterceptor } from "../../services/AuthInterceptor.Service";

const getRows = (data) => {
  if (Array.isArray(data?.r)) return data.r;
  if (Array.isArray(data?.r?.data)) return data.r.data;
  if (Array.isArray(data?.r?.docs)) return data.r.docs;
  if (Array.isArray(data?.r?.roles)) return data.r.roles;
  if (Array.isArray(data?.data)) return data.data;
  if (Array.isArray(data?.data?.data)) return data.data.data;
  if (Array.isArray(data?.result)) return data.result;
  return [];
};

const SubAdminsList = () => {
  const [roles, setRoles] = useState([]);

  useEffect(() => {
    const loadRoles = async () => {
      const response = await AuthInterceptor("/admin/role?page=1&limit=100", {
        method: "GET",
      });
      setRoles(getRows(response.data));
    };
    loadRoles();
  }, []);

  return (
    <AdminCrudPage
      title="Sub Admins"
      listPath="/admin/sub-admin"
      addPath="/admin/sub-admin"
      editPath={(id) => `/admin/sub-admin/${id}`}
      deletePath={(id) => `/admin/sub-admin/${id}`}
      getByIdPath={(id) => `/admin/sub-admin/${id}`}
      statusPath={(id) => `/admin/sub-admin/${id}`}
      statusMethod="PUT"
      statusBody={(row, nextStatus) => ({ isActive: nextStatus })}
      transformBody={(body, mode) => {
        if (mode !== "edit") return body;
        const { newPassword, ...updatedBody } = body;
        if (newPassword?.trim()) updatedBody.password = newPassword.trim();
        return updatedBody;
      }}
      showStatusAction={false}
      addButtonLabel="Add Sub Admin"
      fields={[
        { name: "fullName", label: "Full Name" },
        { name: "mobileNumber", label: "Mobile Number" },
        { name: "email", label: "Email", type: "email" },
        { name: "password", label: "Password", type: "password", hideOnEdit: true },
        {
          name: "newPassword",
          label: "New Password (leave empty to keep current password)",
          type: "password",
          placeholder: "New Password",
          hideOnAdd: true,
        },
        {
          name: "roleId",
          label: "Role",
          type: "select",
          options: roles
            .map((role) => ({
              value: role._id || role.id,
              label: role.name || role.title || role.roleName || "Role",
            }))
            .filter((role) => role.value),
        },
        { name: "isActive", label: "Active", type: "checkbox", hideOnAdd: true },
      ]}
      columns={[
        { key: "fullName", label: "Name" },
        { key: "email", label: "Email" },
        { key: "mobileNumber", label: "Mobile" },
        { key: "roleName", label: "Role" },
        {
          key: "isActive",
          label: "Status",
          render: (value, row, actions) => (
            <span
              className={`badge ${value ? "bg-success" : "bg-secondary"}`}
              role="button"
              onClick={() => actions.toggleStatus(row)}
            >
              {value ? "Active" : "Inactive"}
            </span>
          ),
        },
      ]}
      searchFields={["fullName", "email", "mobileNumber"]}
    />
  );
};

export default SubAdminsList;
